import { render, staticRenderFns } from "./FrzPackingContainers.vue?vue&type=template&id=1acbda5a"
import script from "./FrzPackingContainers.vue?vue&type=script&lang=js"
export * from "./FrzPackingContainers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports